
import { EFilter, EProjectType } from '@/helpers/enums'
import { searchProjects } from '@/helpers/search'

const TOTAL_VISIBLE_RESULTS = 6

export default {
  name: 'Projects',
  layout: 'portal',
  middleware: ['public-search-disabled', 'search-redirect'],

  async asyncData({ app, route, query, store, redirect, error }) {
    const enableIPDetectionSearch = app.$useConfig(app.$EClientConfig.ENABLE_IP_DETECTION)

    function makePreSelectedLocale(locations) {
      const detectedLoc = store.state.sessionCountry
      const loc = locations.filter((e) => !e.isCountry && e.country === detectedLoc)
      const preSelected = loc.length ? loc : []
      const locationQuery = preSelected.map((e) => {
        const uriComp = `${e.country}:${e.value}:0`
        return encodeURIComponent(uriComp)
      })

      if (locationQuery.length) {
        redirect({
          query: {
            [EFilter.LOCATION]: locationQuery.join(','),
            [EFilter.PAGE]: query?.[EFilter.PAGE] ? query[EFilter.PAGE] : 1
          }
        })
      }
    }

    try {
      await store.dispatch('filters/getLocations')
      await store.dispatch('filters/getJobTypes', store.state.clientContext.name)

      const queryRule = Object.keys(route.query).some((e) => e)

      if (enableIPDetectionSearch && store.state.sessionCountry && !queryRule) {
        makePreSelectedLocale(store.state.filters.getLocations)
      }

      const { currentOffset, results, total } = await searchProjects({
        pageSize: TOTAL_VISIBLE_RESULTS,
        context: app,
        type: EProjectType.PUBLIC,
        route
      })

      if (currentOffset && currentOffset >= total) {
        app.$resetPage(route.query)
      }

      store.commit('SEO_INDEX', total !== 0)

      return {
        listResults: results,
        listResultsTotal: total,
        currentOffset
      }
    } catch (err) {
      error({
        statusCode: err.response?.status,
        message: err.response?.statusText
      })
    }
  },
  data() {
    return {
      mobileFilters: false
    }
  },
  auth: false,

  head() {
    return this.$headMetaTags({
      title: this.$t('talent.project.search.meta.title'),
      keywords: this.$t('talent.project.search.meta.keywords'),
      description: this.$t('talent.project.search.meta.description')
    })
  },

  computed: {
    totalVisible() {
      return TOTAL_VISIBLE_RESULTS
    }
  },

  watchQuery: [
    EFilter.PAGE,
    EFilter.TEXT,
    EFilter.POOLS,
    EFilter.LOCATION,
    EFilter.USER_LOCATION,
    EFilter.WORK_PREFS,
    EFilter.HOURS,
    EFilter.DURATION,
    EFilter.OPEN_ONLY,
    EFilter.JOB_TYPE
  ]
}
